export const updateFilesInProduct = (payload?: any) => ({
    type: "@saga/UPDATE_FILES_IN_PRODUCT",
    payload
});

